export enum AppointmentCreatedBy {
  Account = 0,
  Customer
}
